var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataAfterSalesReason.table.code"),
                prop: "reasonCode",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  disabled: "",
                  placeholder: _vm.$t(
                    "SettingBaseDataAfterSalesReason.table.generated"
                  ),
                  clearable: "",
                },
                model: {
                  value: _vm.form.reasonCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reasonCode", $$v)
                  },
                  expression: "form.reasonCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "SettingBaseDataAfterSalesReason.table.description"
                ),
                prop: "reasonDescribe",
              },
            },
            [
              _c("BjInput", {
                attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                model: {
                  value: _vm.form.reasonDescribe,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reasonDescribe", $$v)
                  },
                  expression: "form.reasonDescribe",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }